import React, {useState, useRef} from "react";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import CarouselSlide from './CarouselSlide'
import { Trans } from "react-i18next";
import PlaceholderMedia from '../PlaceholderMedia';
import ImagenValidada from './ActividadesUtils/RecursosValidados/ImagenValidada';

const CustomCarousel = ({ carouselData, instrucciones, isGeneratingPDF = false }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  
  // Solo mostrar placeholder si se pasa explícitamente isGeneratingPDF
  const reemplazarRecursos = new URLSearchParams(window.location.search).get('reemplazarRecursos') === 'true';
  
  const responsive = {
    desktop: {
      breakpoint: { max: 10000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const orderedData = carouselData.sort((a, b)=>{
    if(a.orden > b.orden){
      return 1
    }else{
      return -1
    }
  })

  // En modo PDF, el carrusel interactivo solo deja ver (y por lo tanto
  // capturar) la diapositiva actual: aquí se listan todos los elementos uno
  // debajo del otro para que ninguno se pierda en el documento estático.
  // Sin aspect-ratio ni object-cover: la imagen se muestra completa, a su
  // proporción natural, sin recortarse. "carrusel-pdf-items" marca el
  // contenedor para que cada diapositiva (imagen + texto) se pagine como una
  // sola pieza y nunca se separen entre páginas distintas.
  if (isGeneratingPDF) {
    return (
      <>
        <div className="lg:mt-8"></div>
        {instrucciones && <div className="block-instructions mb-4">{instrucciones}</div>}
        <div className="my-4 w-full carrusel-pdf-items">
          {orderedData.map((item, index) => (
            <div key={index} className="mb-8">
              {item.imagen && (
                <ImagenValidada
                  src={item.imagen}
                  className="mx-auto block w-full max-w-md rounded-xl mb-2 shadow border"
                />
              )}
              {(item.video || item.audio) && (
                <PlaceholderMedia
                  tipo={item.video ? "video" : "audio"}
                  nombreArchivo={reemplazarRecursos ? (item.video || item.audio) : null}
                />
              )}
              {item.texto && (
                <div className="text-nimbusLight text-sm md:text-base text-justify mt-2">{item.texto}</div>
              )}
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
    <div className="lg:mt-8"></div>
    {instrucciones && <div className="block-instructions mb-4">{instrucciones}</div>}
    {/* <div className="text-center text-nimbusLight  font-bold md:hidden mb-2">{`Diapositiva ${currentSlide + 1} de ${carouselData.length}`}</div> */}
    <div className="text-center text-nimbusLight  font-bold md:hidden mb-2">
      <Trans i18nKey="slide"></Trans>
      <div className="mx-1 inline-block">{currentSlide + 1}  </div>
      <Trans i18nKey="slideOf"></Trans>
      <div className="mx-1 inline-block">{carouselData.length}</div>
    </div>
      <Carousel
        ssr
        responsive={responsive}
        showDots={true}
        keyBoardControl={true}
        infinite={false}
        className="mb-[4rem] z-[5] custom-carousel"
        afterChange={(nextSlide, { currentSlide, onMove }) => {
          setCurrentSlide(currentSlide)
        }}
      >
        {orderedData.map((item, index) => (
          <>
          <CarouselSlide slideData={item} key={index} currentSlide={currentSlide} index={index}/>
          </>
        ))}
      </Carousel>
    </>
  );
};

export default CustomCarousel;
